Vue.component('average-rating-chart', {
    props: [
        'fromDate',
        'toDate',   // YYYY-MM-DD formatted
        'isLoading',
        'text_color',
        'category',
        'fontSize'
    ],

    watch: {
        category: function (val) {
            this.updateCategory()
        },
    },
    template:`
        <div class="chart-area-wrapper">
            <div class="overflow-auto">
                <div class="chart-wrapper scroll-x">
                    <canvas ref="average_chart" id="ratings_chart" width="1000" height="350" style="position:relative;"></canvas>
                </div>
            </div>
            <div v-if="tooltipModel && tooltipModel.body" class="chart-tooltip" :style="tooltipStyle">
                <div class="chart-tooltip-inner">
                    <div class="rich-label" :style="richLabelStyle" @mouseover="noDisplay = true">
                        <span class="small" v-html="richLabelTop"></span>
                        <p><strong v-html="richLabelBottom"></strong></p>
                    </div>
                    <div class="body text-center">
                        <p class="label">Average Stars</p>
                        <p>
                            <span class="score">{{ tooltipModel.dataPoints[0].yLabel }}%</span>
                            <i :class="arrowClasses"></i>
                            <strong :class="{'text-success': scoreDiff > 0, 'text-danger': scoreDiff < 0}" v-show="scoreDiff !=0">
                                {{ scoreDiff }}
                            </strong>
                        </p>
                        <a href="#" :style="linkStyle" @click="filterFromChart($event)">
                            {{ numOfReviews }}
                        </a>
                    </div>
                </div>
            </div>
        </div>`,

    computed: {
        isCurrentDatapointHovered() {
            // Use datasetIndex to differentiate between current/previous (0 current, 2 previous)
            return this.tooltipModel.dataPoints[0].datasetIndex == 0; 
        },

        hoveredDatapoint() {
            return this.tooltipModel.dataPoints[0];
        },
        
        numOfReviews() {
            const index = this.hoveredDatapoint.index;
            // Use datasetIndex to differentiate between current/previous (0 current, 2 previous)
            const reviews = this.isCurrentDatapointHovered 
                ? this.review_counts.current[index] 
                : this.review_counts.previous[index]

            return `SEE ${reviews} REVIEWS`;
        },

        richLabelStyle() {
            return {
                background: this.isCurrentDatapointHovered ? '#00aef1' : '#f573db',
            };
        },
    
        linkStyle() {    
            return {
                color: this.isCurrentDatapointHovered ? '#00aef1' : '#f573db',
            };
        },

        tooltipStyle() {
            const height = this.dividerType == 'week' ? 250 : 228;
            return {
                opacity: this.tooltipHidden ? 0 : 1,
                display: this.noDisplay ? 'none' : 'block',
                position: 'absolute',
                left: this.hoveredDatapoint.x - 60 + 'px',
                top: this.hoveredDatapoint.y - height + 'px',
                fontFamily: this.tooltipModel._bodyFontFamily,
                fontSize: this.tooltipModel.bodyFontSize + 'px',
                fontStyle: this.tooltipModel._bodyFontStyle,
            }
        },
        richLabelTop() {

            let label_top = ""
            try {
                label_top = this.tooltipModel && this.tooltipModel.title ?
                    this.getRichLabelFromSmallLabel(this.tooltipModel.title[0])[0] : ""
            } catch (error) {
                //
            }

            return label_top
        },
        richLabelBottom() {
            var label = this.getRichLabelFromSmallLabel(this.tooltipModel.title[0])
            return label ? label[1] : ''
        },
        scoreDiff() {
            const previousIndex = this.isCurrentDatapointHovered ? 2 : 0;
            if ( !this.chart.data.datasets[previousIndex].data.length ) {
                return 0
            }

        	let currentValue = this.hoveredDatapoint.yLabel
            let currentIndex = this.hoveredDatapoint.index

            let previousValue = currentIndex < this.chart.data.datasets[previousIndex].data.length ?
                this.chart.data.datasets[previousIndex].data[currentIndex] : -1

            return (currentValue - previousValue).toFixed(2)
        },
        arrowClasses() {
            let currentValue = this.hoveredDatapoint.yLabel
            let currentIndex = this.hoveredDatapoint.index

            const previousIndex = this.isCurrentDatapointHovered ? 2 : 0;
            let previousValue = currentIndex < this.chart.data.datasets[previousIndex].data.length ?
                this.chart.data.datasets[previousIndex].data[currentIndex] : -1

            let classes = []

            if (previousValue == -1 || previousValue == currentValue) {
                classes.push('ei-minus-06')
            } else if (currentValue > previousValue) {
                classes.push('text-success')
                classes.push('ei-arrow_up')
            } else {
                classes.push('text-danger')
                classes.push('ei-arrow_down')
            }

            return classes
        }
    },

    data() {
        return {
            chart: null,
            noDisplay: false,
            params: {
                fromDate: this.fromDate,
                toDate: this.toDate,
            },
            dividerType: 'day',
            currentAverages: null,
            previousAverages: null,
            labels: null,
            tooltipModel: null,
            comparison: null,
            tooltipHidden: true,
            tooltip_labels: { 'current': [], 'previous': [] },
            param_queries: { 'current': [], 'previous': [] },
            review_counts: { 'current': [], 'previous': [] },
            reviewScoresLine: {
                label: __('Current Rating'),
                type: 'line',
                data: [],
                fill: false,
                borderColor: 'rgb(0, 173, 241)',
                lineTension: 0,
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointStrokeColor: 'rgba(0, 173, 241, 1)',
                pointRadius: 5,
                pointHitDetectionRadius : 15,
                pointBorderWidth: 2.5,
                yAxisID: 'y-axis-1',
                xAxisID: 'x-axis-1',
            },
            reviewCompareLine: {
                label: __('Previous Rating'),
                type: 'line',
                data: [],
                fill: false,
                borderColor: 'rgb(245, 115, 219)',
                lineTension: 0,
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointStrokeColor: 'rgba(0, 173, 241, 1)',
                pointRadius: 5,
                pointHitDetectionRadius : 15,
                pointBorderWidth: 2.5,
                yAxisID: 'y-axis-1',
                xAxisID: 'x-axis-1',
            },
            reviewCountsBar: {
                label: __('Current Reviews'),
                type: 'line',
                data: [],
                fill: true,
                lineTension: 0,
                pointStrokeColor: 'rgba(0,0,0,0)',
                strokeColor: 'rgba(0,0,0,0)',
                borderColor: 'rgb(68, 212, 210)',
                categoryPercentage: 0.3,
                backgroundColor: '#00adf180',
                pointBackgroundColor: '#00adf180',
                yAxisID: 'y-axis-2',
                xAxisID: 'x-axis-1',
            },
            previousReviewCountsBar: {
                label: __('Previous Reviews'),
                type: 'line',
                data: [],
                fill: true,
                lineTension: 0,
                pointStrokeColor: 'rgba(0,0,0,0)',
                strokeColor: 'rgba(0,0,0,0)',
                borderColor: 'rgb(139, 114, 245)',
                categoryPercentage: 0.3,
                backgroundColor: 'rgba(169,169,169, 0.3)',  
                pointBackgroundColor: 'rgba(255, 255, 255, 0)',
                yAxisID: 'y-axis-2',
                xAxisID: 'x-axis-1',
            },
        }
    },

    mounted() {

        Chart.defaults.global.legend.labels.usePointStyle = true;
        Chart.defaults.global.legend.labels.position = 'bottom';

        var area = this.$refs.average_chart;

        var vue_instance = this;

        let ctx = area.getContext("2d")

        let gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(0, 0, 0, 0.14)');
        gradient.addColorStop(1, 'rgba(255, 255, 255, 0.14)');

        this.reviewCountsBar.backgroundColor = gradient

        this.chart = new Chart(area, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [this.reviewScoresLine, this.reviewCountsBar, this.reviewCompareLine, this.previousReviewCountsBar]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'bottom',
                        labels: {
                            defaultFontFamily: "'Open Sans'",
                            defaultFontSize: this.fontSize || 25,
                            fontSize: this.fontSize || 14,
                            generateLabels: function(chart) {
                                const datasets = chart.data.datasets;
                                return datasets.map((dataset, i) => {
                                    let pointStyle = 'circle';  
                                    let fillStyle = 'transparent';  
                                    
                                    // Customize for specific datasets
                                    if (dataset.label === 'Current Reviews' || dataset.label === 'Previous Reviews') {
                                        pointStyle = 'rect'; 
                                        fillStyle = dataset.backgroundColor || dataset.borderColor;  
                                    }
                            
                                    return {
                                        text: dataset.label,  
                                        fillStyle: fillStyle,  
                                        hidden: !chart.isDatasetVisible(i), 
                                        strokeStyle: dataset.borderColor,  
                                        lineCap: dataset.borderCapStyle,
                                        lineDash: dataset.borderDash,
                                        lineDashOffset: dataset.borderDashOffset,
                                        lineJoin: dataset.borderJoinStyle,
                                        pointStyle: pointStyle,  
                                        datasetIndex: i  
                                    };
                                });
                            }
                            
                        }
                    },
                    scales : {
                        yAxes : [
                            {
                                type: 'linear',
                                id: 'y-axis-1',
                                ticks : {
                                    max: 100,
                                    stepSize: 20,
                                    beginAtZero: false,
                                    fontColor: this.text_color,
                                    fontSize: this.fontSize || 14
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'R A T I N G S',
                                    fontColor: this.text_color,
                                    fontSize: this.fontSize || 14
                                },
                                gridLines: {
                                    color: "rgb(173, 173, 173, 0.2)"
                                }
                            },
                            {
                                ticks: {
                                    // max: 5,
                                    beginAtZero: false,
                                    fontColor: this.text_color,
                                    fontSize: this.fontSize || 14
                                    // stepSize: 1
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'N U M B E R  O F  R E V I E W S',
                                    fontColor: this.text_color,
                                    fontSize: this.fontSize || 14
                                },
                                position: 'right',
                                type: 'linear',
                                id: 'y-axis-2',
                                gridLines: {
                                    display: false,
                                    color: "#f2f2f2"
                                }
                            }
                        ],
                        xAxes : [
                            {
                                display: false,
                                ticks: {
                                    fontSize: this.fontSize || 14,
                                    fontColor: this.text_color
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'T I M E',
                                    fontSize: this.fontSize || 14,
                                    fontColor: this.text_color
                                },
                                gridLines: {
                                    display: false
                                }
                            },
                            {
                                id: 'x-axis-1',
                                ticks: {
                                    fontSize: this.fontSize || 14,
                                    fontColor: this.text_color
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        
                        // Disable the on-canvas tooltip
                        enabled: false,
                        intersect: false,
                        mode: 'nearest',
                    
                        custom: function(tooltipModel) {
                            if (!tooltipModel || !tooltipModel.title || !tooltipModel.dataPoints) {
                                vue_instance.tooltipHidden = true;
                                return;
                            }

                            // Since we are using nearest mode, we need to make sure that we only show the tooltip
                            // If we are hovering above points (indexes 0 and 2)
                            const validDatapoint = tooltipModel.dataPoints.length >= 1 
                                && tooltipModel.dataPoints[0].datasetIndex == 0 
                                || tooltipModel.dataPoints[0].datasetIndex == 2
                            if (!validDatapoint) { 
                                vue_instance.tooltipHidden = true;
                                return;
                            }
                            
                            const isCurrentDatasetVisible = vue_instance.chart.isDatasetVisible(0);  
                            if (isCurrentDatasetVisible && tooltipModel.dataPoints[0].datasetIndex == 2) {
                                const isCurrentDatasetEmpty = vue_instance.currentAverages.labels.length == 0;
                                // Only enforce this constraint if the current dataset is not empty and we have something to show
                                if (!isCurrentDatasetEmpty) {
                                    vue_instance.tooltipHidden = true;
                                    return;
                                }
                            }
                            
                            vue_instance.tooltipModel = tooltipModel;
                            vue_instance.tooltipHidden = false;
                            vue_instance.noDisplay = false;
                        }
                    }
                    
                }
        });

        var instance = this;

        if ( !this.isLoading ) {
            this.updateChart(this.params)
        }

        // if (true) {
        //     var url = chart.toBase64Image()
        //     document.getElementById("chart-image").src = url;
        // }

        this.$eventHub.$on('update-home-dates', (from, to, dateRangeString) => {
        	let params = {fromDate: from, toDate: to, category: this.category}
        	this.updateChart(params)
    	});
    },

    methods: {

        removeTooltip() {
            this.tooltipModel = null
        },

        updateCategory() {
            let params = {fromDate: this.fromDate, toDate: this.toDate, category: this.category}
            this.updateChart(params)
        },

        updateChart(params) {

            var params_string = Object.keys(params).map(function(k) {

                return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])

            }).join('&')

            if (this.compareOn) {
            	this.addComparisonChart(this.params)
            }

            axios.get('/api/overview/' + Spark.state.currentTeam.id + "/averages/?" + params_string)
                .then(response => {

                    this.currentAverages = response.data[0]
                    this.previousAverages = response.data[1]
                    this.labels = response.data[2]
                    this.dividerType = response.data[3];  
                    this.prepareAndUpdateChart()

                }
            );

        },
        prepareAndUpdateChart() {
            this.chart.data.labels = this.labels;
            this.param_queries.current = this.currentAverages.params;
            this.param_queries.previous = this.previousAverages.params;
            this.review_counts.current = this.currentAverages.review_counts;
            this.review_counts.previous = this.previousAverages.review_counts;
            this.tooltip_labels.current = this.currentAverages.labels;
            this.tooltip_labels.previous = this.previousAverages.labels;

            // Set data for the reviews line chart
            this.chart.data.datasets[0].data = this.currentAverages.averages;
            this.chart.data.datasets[2].data = this.previousAverages.averages;
            
            this.chart.data.datasets[1].data = this.review_counts.current;
            this.chart.data.datasets[3].data = this.review_counts.previous;

            this.chart.update();
        },
        filterFromChart(event) {
            event.preventDefault()

            const index = this.hoveredDatapoint.index;
            const params = this.isCurrentDatapointHovered
                ? this.param_queries.current[index] 
                : this.param_queries.previous[index]
            params.fromDate = params.fromDate.substring(0, 10)
            params.toDate = params.toDate.substring(0, 10)
            params.ratingsCategory = this.category != 'overall_average' ? this.category : ''

            $('.spark-settings-tabs a[href$="#reviews"]').tab('show');

            this.$eventHub.$emit('applyFilters', params);
        },
        // Gets a rich label to be displayed in an HTML form
        // from a simple textual label
        getRichLabelFromSmallLabel(label) {
            const richLabel = this.isCurrentDatapointHovered ? this.tooltip_labels.current[label] : this.tooltip_labels.previous[label]
            return richLabel;
        }
    }
});
